//hooks
import { useDefaultImage } from 'utils/hooks/useDefaultImage';
import useTranslations, { RU_LANGUAGE, UK_LANGUAGE } from 'languages';
import { useRouter } from 'next/router';
import { useCheckPlug } from 'utils/CheckPlug';
import useGetColor from 'utils/hooks/useGetColor';
import { useLink } from 'utils/hooks/useLink';

//types
import { SeoType } from 'types/api/itemsResponseType';

// Styles
import { Description } from '../NewCard/style';
import { Img, TitleSP, TitleSPLink, UntranslatedWrap, Wrap } from './style';

//utils
import { returnUntranslatedHref } from 'utils/returnUntranslatedHref';

type Translation = {
  title?: string;
  sub_title?: string;
  slug?: string;
  link?: string;
  image?: string;
};

type NewsData = {
  translationData?: Translation;
  id?: string;
  image?: string | null;
  title?: string;
  sub_title?: string;
  ifTranslationIsNull?: object;
  seo?: SeoType;
  link?: string;
  s3?: string;
  categoriesByLang?: Array<object>;
};

export const SpecialProjectCard = ({
  data = {
    image: '',
    s3: '',
    translationData: {},
    seo: {},
  },
}: {
  data?: NewsData;
}) => {
  const t = useTranslations();

  const { image = '', s3 = '', translationData = {}, seo = {} } = { ...data };

  const { title = '', image: imageMain = '' } = { ...translationData };

  const {
    slug_ru = '',
    slug_en = '',
    slug_uk = '',
    title_uk = '',
    title_ru = '',
    title_en = '',
  } = seo;

  const { defaultImage = '' } = useDefaultImage(
    image || '',
    s3 || '',
    imageMain || '',
    undefined,
    undefined
  );

  const link = useLink();

  const { locale = '' } = useRouter();

  const slugDiferLang =
    locale === UK_LANGUAGE ? slug_uk : locale === RU_LANGUAGE ? slug_ru : slug_en;
  const linkPlug = useCheckPlug();
  const moduleColor = useGetColor();
  return (
    <>
      {title ? (
        <Wrap
          href={slugDiferLang ? `${link}/special_progect/${slugDiferLang}` : ''}
          module_color={moduleColor}
        >
          <Img width={175} height={175} src={defaultImage} alt="special progect image" />
          <TitleSP>{title}</TitleSP>
        </Wrap>
      ) : (
        <UntranslatedWrap module_color={moduleColor}>
          <Img width={175} height={175} src={defaultImage} />
          <Description className="special_project">
            {t('textForUntranslatedArticleFirstPart')}
            {title_en && (
              <>
                <TitleSPLink
                  className="translation"
                  href={returnUntranslatedHref({
                    locale: 'en',
                    currentPlug: linkPlug,
                    additionalSlug: '/special_progect',
                    slug: slug_en || '',
                  })}
                >
                  {title_en}
                </TitleSPLink>
                {t('versionArticleEn')}
              </>
            )}
            {title_ru && (
              <>
                <TitleSPLink
                  className="translation"
                  href={returnUntranslatedHref({
                    locale: 'ru',
                    currentPlug: linkPlug,
                    additionalSlug: '/special_progect',
                    slug: slug_ru || '',
                  })}
                >
                  {title_ru}
                </TitleSPLink>
                {t('versionArticleRu')}
              </>
            )}
            {title_uk && (
              <>
                <TitleSPLink
                  className="translation"
                  href={returnUntranslatedHref({
                    locale: '',
                    currentPlug: linkPlug,
                    additionalSlug: '/special_progect',
                    slug: slug_uk || '',
                  })}
                >
                  {title_uk}
                </TitleSPLink>
                {t('versionArticleUk')}
              </>
            )}
          </Description>
        </UntranslatedWrap>
      )}
    </>
  );
};
